import { Navigate, Route, Routes } from "react-router-dom";
import ReportPage from "./pages/ReportPage";
import Layout from "./shared/components/layout/Layout";
import AuthLayout from "./shared/components/layout/AuthLayout";
import ReportItemsPage from "./pages/ReportItemsPage";
import ReportSummaryPage from "./pages/ReportSummaryPage";
import ReportItemFormPage from "./pages/ReportItemFormPage";
import LoginPage from "./pages/LoginPage";
import BusinessEntityProfilePage from "./pages/BusinessEntityProfilePage";
import InstructionsPage from "./pages/Instructions";
import ErrorsPage from "./pages/ErrorsPage";
import MessagesPage from "./pages/MessagesPage";
import NotFoundPage from "./pages/NotFoundPage";
import ProtectedRoutes from "@/ProtectedRoutes";

export default function AppRouter() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route index element={<LoginPage />} />
      </Route>
      <Route path="/" element={<Layout />}>
        <Route path="instructions" element={<InstructionsPage />} />
      </Route>
      <Route element={<ProtectedRoutes />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/reports/summaries" replace />} />
          <Route path="profile" element={<BusinessEntityProfilePage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="report/:reportId?" element={<ReportPage />} />
          <Route
            path="reports/versions/:versionId/items"
            element={<ReportItemsPage />}
          />
          <Route
            path="reports/versions/:versionId/errors"
            element={<ErrorsPage />}
          />
          <Route
            path="reports/versions/:versionId/items/:itemId"
            element={<ReportItemFormPage />}
          />
          <Route
            path="reports/versions/:versionId/items/new"
            element={<ReportItemFormPage />}
          />
          <Route path="reports/summaries" element={<ReportSummaryPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
